import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  IsShowLoader=false;
  // Components call these from lifecycle hooks during change detection; deferring the update to a
  // microtask avoids NG0100 (ExpressionChangedAfterItHasBeenChecked) on the AppComponent loader overlay
  showLoader() {
    Promise.resolve().then(() => this.IsShowLoader=true);
  }
  hideLoader() {
    Promise.resolve().then(() => this.IsShowLoader=false);
  }

  hidefinalLoader() {
      setTimeout(() => {
        this.IsShowLoader=false;
      }, 4000);
    }
  }
  
